<template>
  <el-col :span="formTable.itemSpan || itemSpan">
    <el-row>
      <el-col
        :span="formTable.labelSpan || labelSpan"
        class="shadow"
      >
        <div class="label">
          {{label}}
        </div>
      </el-col>
      <el-col
        :span="formTable.contentSpan || contentSpan"
        class="shadow"
      >
        <div class="content" v-if="!$slots.default">
          {{formTable.data[prop]}}
        </div>
        <div class="content" v-else>
          <slot></slot>
        </div>
      </el-col>
    </el-row>
  </el-col>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'formTableItem',

  inject: ['formTable'],

  props: {
    prop: String,
    label: String,
    labelSpan: {
      type: Number,
      default: 12
    },
    contentSpan: {
      type: Number,
      default: 12
    },
    itemSpan: {
      type: Number,
      default: 12
    }
  },

  data() {
    return {

    }
  },

  methods: {

  },
}
</script>

<style lang="scss" scoped>
$color: #EBEEF5;
.shadow {
  box-shadow: 1px 1px 0px $color;
  font-size: 12px;
}

.label {
  text-align: right;
}
.content {
  text-align: left;
}
.label,
.content {
  padding: 10px 5px;
  box-sizing: border-box;
  min-height: 32px;
}

.label {
  font-weight: 700;
}

.form-table-item {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/FormTable/form-table-item.vue